import React from 'react';
import ImageCropDialogPresenter from './ImageCropDialogPresenter';

interface Props {
  state: {
    isOpen: boolean;
    file_key: string;
    file_name: string;
    aspect: number;
  };
  onSubmit: (file: { file_name: string; blob: Blob }) => Promise<boolean>;
  onClose: () => void;
  onUpdateProfileImage: (_: any) => void;
}

const ImageCropContainer = (props: Props) => {
  return <ImageCropDialogPresenter {...props} />;
};

export default ImageCropContainer;
